import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvitationRoutingModule } from './invitation-routing.module';
import { InvitationComponent } from './invitation.component';
import { FooterModule } from 'src/app/shared/footer/footer.module';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { NgZorroAntdModule } from 'src/app/modules/nz-zorro-antd.module';
import { NgZorroIconModule } from 'src/app/modules/nz-icon-antd.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsModule } from 'src/app/shared/validation-errors/validation-errors.module';
import { InputFieldModule } from 'src/app/shared/input-field/input-field.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    InvitationComponent
  ],
  imports: [
    CommonModule,
    InvitationRoutingModule,
    HeaderModule,
		FooterModule,
    NgZorroAntdModule,
		NgZorroIconModule,
		ReactiveFormsModule,
		HeaderModule,
		FooterModule,
		ValidationErrorsModule,
		InputFieldModule,
		TranslateModule
  ],
  exports: [
    InvitationComponent
  ]
})
export class InvitationModule { }
